export default "__VITE_ASSET__BANRnwRD__"